<template>
	<div>
		<div>
			<el-carousel trigger="click" height="500px">
			  <el-carousel-item v-for="(item, index) in images" :key="index">
			    <el-image
			      style="width: 100%; height: 500px"
			      :src="item"
			      fit="fill"
			    ></el-image>
			  </el-carousel-item>
			</el-carousel>
		</div>
		<div style="width: 70%;margin: auto;">
			<p style="width: 421px;margin: 5px auto;border-bottom: 5px solid red;line-height: 30px;">会讯|中华医学会第二十五次全国皮肤性病学术年会召开在即</p>
			<p style="font-size: 14px;text-indent: 2em;">2019年4月25日～28日，由中华医学会皮肤性病学分会举办的中华医学会第二十五次全国皮肤性病学术年会将于广东省珠海市珠海国际会展中心召开。</p>
			<p style="font-size: 14px;text-indent: 2em;">本次大会以“引领学术，共创未来”为主题，将继续传承以往的经典学术内容，推进栏目和内容的优化。</p>
			<p style="font-size: 14px;text-indent: 2em;">此外，大会在保留原有优秀学术内容的基础上，新增特色栏目及邀请国内外知名专家演讲和授课，努力打造满足各级临床医师和科研工作者需求的高质量的年会平台。</p>
			<p style="font-size: 14px;text-indent: 2em;">芙清和芙汭本次也受邀参加大会（大会展位号：146、147、184、185），期待各位同学前来一同交流。大会期间我们还会举行抽奖活动，更有神秘新品大礼送出。</p>
			<p>
				<el-image
				  style="width: 100%;"
				  src="http://www.fulqun.com/uploadfile/2019/0902/20190902071732415.gif"
				  fit="fill"
				></el-image>
			</p>
			
		</div>
		<div class="footer">
			<ul class="putbox">
				<li>© 北京安德普泰医疗科技有限公司 2021 All Rights Reserved.</li>
				<li>邮箱：demon211@sohu.com</li>
				<li>
					地址：北京市大兴区中关村科技园区大兴生物医药产业基地天华大街5号院13号楼11层1104室、1105
				</li>
				<li>
					<a href="https://beian.miit.gov.cn/">京ICP备18032874号-7</a>
				</li>
				<li>
					<a @click="go">互联网产品信息服务资格证书：（京）-非经营性-xxxx-xxxx号</a>
				</li>
			</ul>
			<div class="contactbox">
				<p>010-50846938</p>
				<p>周一至周五 9:00-17:30</p>
				<p>在线客服</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				images: [
				  "https://uplabimg.andupchain.com/%E5%AE%98%E7%BD%91/2d6dd2e5-2093-481b-82df-cd52161e40e5.png",
				],
			}
		},
		methods:{
			go() {
				this.$router.push('/certification')
			}
		}
	}
</script>

<style scoped>
	.footer {
		height: 200px;
		padding: 30px;
		background-color: rgb(250, 250, 250);
		display: flex;
		justify-content: space-between;
	}
	
	.putbox {
		list-style: none;
		font-size: 12px;
		width: 70%;
		margin-top: 10px;
		padding-left: 10%;
		line-height: 30px;
	}
	
	.putbox a {
		text-decoration: none;
		color: #666;
	}
	
	.contactbox {
		width: 30%;
		height: 100%;
		text-align: center;
		line-height: 50px;
	}
	
	.contactbox p:nth-child(1) {
		color: rgb(65, 110, 179);
		font-size: 28px;
	}
	
	.contactbox p:nth-child(2) {
		font-size: 14px;
		color: #666;
	}
	
	.contactbox p:nth-child(3) {
		width: 180px;
		height: 36px;
		margin: auto;
		border: 1px solid rgb(65, 110, 179);
		color: rgb(65, 110, 179);
		line-height: 36px;
		cursor: pointer;
	}
</style>
